import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/capabilities/CapabilitiesSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/why-choose/WhyChooseCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/components/UseCasesCards/UseCasesCards.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/components/UseCasesHero/UseCasesHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/components/UseCasesPricingPlans/UseCasesPricingPlans.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/components/UseCasesProcess/UseCasesProcess.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/components/UseCasesSolutions/UseCasesSolutions.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseDocuments/UseCaseDocuments.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseFAQ/UseCaseFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseHero/UseCaseHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseIndustries/UseCaseIndustries.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseLanguages/UseCaseLanguages.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCasePricingPlans/UseCasePricingPlans.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/use-cases/UseCase/components/UseCaseProcess/UseCaseProcess.tsx");
